(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', '../impersonation'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('../impersonation'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.inherits, global.react, global.impersonation);
    global.RedirectToLogout = mod.exports;
  }
})(this, function (exports, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _inherits2, _react, _impersonation) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.redirectToLogout = undefined;

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _createClass3 = _interopRequireDefault(_createClass2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var redirectToLogout = function redirectToLogout(returnTo) {
    (0, _impersonation.clearAssumedUser)(false);
    window.location.assign(process.env.REACT_APP_AUTH_FLOW_BASE_URI + '/logout' + (returnTo != null ? '?returnTo=' + returnTo : ''));
  };

  var RedirectToLogout = function (_React$Component) {
    (0, _inherits3.default)(RedirectToLogout, _React$Component);

    function RedirectToLogout() {
      (0, _classCallCheck3.default)(this, RedirectToLogout);
      return (0, _possibleConstructorReturn3.default)(this, (RedirectToLogout.__proto__ || Object.getPrototypeOf(RedirectToLogout)).apply(this, arguments));
    }

    (0, _createClass3.default)(RedirectToLogout, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var returnTo = this.props.returnTo;

        redirectToLogout(returnTo);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return RedirectToLogout;
  }(_react2.default.Component);

  exports.default = RedirectToLogout;
  exports.redirectToLogout = redirectToLogout;
});